import {
  MAXIMUM_SELECT_LIST_RANGE_LENGTH,
  YEAR_RANGE_CONTEXT,
} from "CrossFeatureComponents/ExtendedFields/NumberField";
import extendedFieldDataTransformers from "ExtendedFields/dataTransformers";

export function getIsExtendedField(type) {
  return type === extendedFieldDataTransformers.fieldTypes.number;
}

export function getIsInline({ extendedFieldData }) {
  const isExtendedField = getIsExtendedField(extendedFieldData?.type);

  let isInline = true;

  if (isExtendedField) {
    const { minimum, maximum } = extendedFieldData;
    const hasMinimum = typeof minimum === "number";
    const hasMaximum = typeof maximum === "number";

    if (hasMinimum && hasMaximum) {
      const rangeLength = maximum - minimum;
      isInline =
        Number.isNaN(rangeLength) ||
        rangeLength > MAXIMUM_SELECT_LIST_RANGE_LENGTH;
    }
  }

  return isInline;
}

export function getIsYear({ extendedFieldData }) {
  const isExtendedField = getIsExtendedField(extendedFieldData?.type);
  return (
    isExtendedField && extendedFieldData?.rangeContext === YEAR_RANGE_CONTEXT
  );
}

export function getIsValid({ value, extendedFieldData }) {
  const valAsNum = Number.parseFloat(value);
  const isExtendedField = getIsExtendedField(extendedFieldData?.type);
  const isInline = getIsInline({ extendedFieldData });

  if (isExtendedField) {
    const { minimum, maximum } = extendedFieldData;
    const hasMinimum = typeof minimum === "number";
    const hasMaximum = typeof maximum === "number";

    if (isInline) {
      if (hasMinimum && valAsNum < minimum) {
        return false;
      } else if (hasMaximum && valAsNum > maximum) {
        return false;
      }
    }
  }

  return true;
}

export function getTooltipText({ value, extendedFieldData }) {
  const valAsNum = Number.parseFloat(value);
  const isExtendedField = getIsExtendedField(extendedFieldData?.type);
  const isInline = getIsInline({ extendedFieldData });

  if (isExtendedField) {
    const { minimum, maximum } = extendedFieldData;
    const hasMinimum = typeof minimum === "number";
    const hasMaximum = typeof maximum === "number";

    if (isInline) {
      if (hasMinimum && valAsNum < minimum) {
        return `Must be greater than or equal to ${minimum}`;
      } else if (hasMaximum && valAsNum > maximum) {
        return `Must be less than or equal to ${maximum}`;
      }
    }
  }

  return value;
}
